import {
  Box,
  Button,
  Icon,
  Stack,
  Text,
  useDisclosure,
  Wrap,
} from "@chakra-ui/react";
import Td from "@splitfire-agency/raiden-library/dist/components/Table/Td";
import Tr from "@splitfire-agency/raiden-library/dist/components/Table/Tr";
import { IoSearchOutline } from "react-icons/io5";
import { FormattedMessage, useIntl } from "react-intl";
import CollapseAnimation from "../../../components/Animations/Collapse";
import ResourceState from "../../../components/Resource/ResourceState";
import {
  CUSTOMERS_DOCUMENTS_STATES,
  CUSTOMERS_DOCUMENTS_STATES_VALUE_NOT_SENT,
  CUSTOMERS_DOCUMENTS_STATES_VALUE_REFUSED,
} from "../../../constants/customersDocuments";
import useInterpolateTranslatedField from "../../../hooks/useInterpolateTranslatedField";
import PagesModal from "./PagesModal";

/**
 * @typedef {object} Props
 * @property {number} userId
 * @property {"customer" | "holder"} userType
 * @property {import("../../../types/Document").Document} document
 * @property {import("../../../types/CustomerDocument").CustomerDocument} [customerDocument]
 * @property {() => void} mutateCustomerDocument
 *
 * @param {Props} props
 */
function Row({
  userId,
  userType,
  document,
  mutateCustomerDocument,
  customerDocument,
}) {
  const intl = useIntl();

  const translate = useInterpolateTranslatedField();

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <PagesModal
        userType={userType}
        userId={userId}
        document={document}
        customerDocument={customerDocument}
        mutateCustomerDocument={mutateCustomerDocument}
        isOpen={isOpen}
        onClose={onClose}
      />

      <Tr>
        <Td>
          <Stack spacing=".5rem">
            <Text>{translate(document.name)}</Text>

            <Text colorScheme="gray">{translate(document.infos)}</Text>
          </Stack>
        </Td>

        <Td>
          <ResourceState
            state={
              customerDocument?.state ??
              CUSTOMERS_DOCUMENTS_STATES_VALUE_NOT_SENT
            }
            customStates={CUSTOMERS_DOCUMENTS_STATES}
          />

          <CollapseAnimation
            in={
              customerDocument?.state ===
              CUSTOMERS_DOCUMENTS_STATES_VALUE_REFUSED
            }>
            <Text colorScheme="red" fontSize="0.75rem" pt=".5rem">
              {intl.formatMessage(
                { defaultMessage: "Motif de refus: {reason}" },
                { reason: customerDocument?.review },
              )}
            </Text>
          </CollapseAnimation>

          {customerDocument && (
            <Box fontSize="0.75rem" mt=".5rem">
              <Text>
                {intl.formatMessage(
                  { defaultMessage: "Envoyé: {date} {time}" },
                  {
                    date: intl.formatDate(customerDocument.created_at, {
                      dateStyle: "short",
                    }),
                    time: intl.formatTime(customerDocument.created_at, {
                      timeStyle: "short",
                    }),
                  },
                )}
              </Text>

              <CollapseAnimation
                in={
                  customerDocument.state ===
                    CUSTOMERS_DOCUMENTS_STATES_VALUE_REFUSED &&
                  customerDocument.review_at !== null
                }>
                <Text>
                  {customerDocument.review_at &&
                    intl.formatMessage(
                      { defaultMessage: "Refusé: {date} {time}" },
                      {
                        date: intl.formatDate(customerDocument.review_at, {
                          dateStyle: "short",
                        }),
                        time: intl.formatTime(customerDocument.review_at, {
                          timeStyle: "short",
                        }),
                      },
                    )}
                </Text>
              </CollapseAnimation>
            </Box>
          )}
        </Td>

        <Td>
          <Wrap spacing=".5rem">
            <Button
              onClick={onOpen}
              variant="outline"
              colorScheme="gray"
              leftIcon={<Icon as={IoSearchOutline} />}>
              <FormattedMessage defaultMessage="Détail" />
            </Button>
          </Wrap>
        </Td>
      </Tr>
    </>
  );
}

export default Row;
